/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';

// material
import {
    Page,
    Content,
} from '@insticator/insticator-ui';
import PageHeader from '../../../../material/structure/pageheader/pageheader';
import PageContent from '../../../../material/structure/pagecontent/pagecontent';
import AdServeBlockingInnards from "./adServeBlockingInnards";

// styles
import injectSheet from 'react-jss';
import styles from './adServeBlocking_styles';


/* ========== ~~~~~~~~~~ GLOBAL SETTINGS - MCM PAGE ~~~~~~~~~~ ========== */

const adServeBlockingPage = injectSheet(styles)((props) => {

    return (
        <Page name={'adServeBlockingPage'}>
            <Content>
                <PageHeader title={'Global Settings'} subtitle={'Ad Serve Blocking'} />
                <PageContent>
                    <AdServeBlockingInnards />
                </PageContent>
            </Content>
        </Page>
    );
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default adServeBlockingPage;